module.exports = __webpack_public_path__ + "static/img/5.1c7a29f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/5.png
// module id = Le6I
// module chunks = 0